<div class="container">
    <div id="rsHeader"></div>
    <div id="uxMessageLabel" *ngIf="uxMessageLabel">
        <div class="row">
            <div class="col-16">
                <p class="bottom-20"><strong>Welcome to the {{insuranceCompany}} Enrollment Center!</strong></p>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <p class="bottom-20"><strong>Note:</strong> Your access to the Enrollment Center is temporarily denied for the following reason(s):</p>
                <!--<p *ngIf="trainingMsg" class="bottom-10">You have not completed the {{planYear}} certification training course. To access Enrollment Center, you must first complete the <a class="link" (click)="GetTrainingURL()" class="link-button" target='_blank'>Online Training  </a>.</p>-->
                <p *ngIf="trainingMsg" class="bottom-10">
                    You have not completed the necessary certification training course.<br />
                    For additional information on training, please visit the <a (click)="GetTrainingURL()">Training and Certification</a> page.
                </p>
                <p *ngIf="backgroundMsg" class="bottom-10">Please note that you will not be be able to access this page further until SilverScript completes processing your background check.</p>
                <p *ngIf="trainingFailedMsg" class="bottom-20">You have failed the {{planYear}} certification training course.</p>
                <p *ngIf="LinceseMsg" class="bottom-20">You do not have a valid state license.</p>
            </div>
        </div>
    </div>
    <div *ngIf="ClickHereVisible && isEnrollmentPageContent">
        <div class="row">
            <div class="col-16">
                <h1>Enrollment</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="bottom-20"><strong>Welcome to the {{insuranceCompany}} Agent Enrollment Center! </strong></p>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <p class="bottom-20"><strong><a  [routerLink]="['../enrollmentInfo']" target="_blank" class="link-button" style="margin-bottom: 12px;"> Click Here </a></strong></p><div [innerHtml]="enrollmentPageContent | safeHtml"></div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div id="uxConetntLabel" *ngIf="isEnrollmentPageContent && !ClickHereVisible" [innerHtml]="enrollmentPageContent | safeHtml"></div>
        </div>
    </div>
</div>
